var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreateApiConnection = function SvgCreateApiConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_api_connection_svg2__b",
    x1: 99.89,
    x2: 34.92,
    y1: 69.05,
    y2: 149.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "create_api_connection_svg2__a",
    x1: 132.92,
    x2: 23.27,
    y1: 3.99,
    y2: 151.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__c",
    x1: 127.07,
    x2: 17.42,
    y1: -0.37,
    y2: 146.91
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__d",
    x1: 182.18,
    x2: 72.53,
    y1: 40.66,
    y2: 187.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__e",
    x1: 159.48,
    x2: 49.83,
    y1: 23.76,
    y2: 171.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__f",
    x1: 182.96,
    x2: 73.31,
    y1: 41.24,
    y2: 188.52
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__g",
    x1: 185.95,
    x2: 76.3,
    y1: 43.47,
    y2: 190.75
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#create_api_connection_svg2__a",
    id: "create_api_connection_svg2__h",
    x1: 141.83,
    x2: 32.17,
    y1: 10.62,
    y2: 157.9
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 74.86,
    cy: 100,
    r: 52.09,
    style: {
      fill: "url(#create_api_connection_svg2__b)",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.04 71.43c3.68-1.5 7.61-2.27 11.58-2.27a2.49 2.49 0 0 0 0-4.98C50 64.39 34.2 80.36 34.2 99.98s15.8 35.59 35.42 35.8a2.49 2.49 0 0 0 0-4.98c-14.75 0-27.42-10.45-30.25-24.92-2.82-14.47 5-28.92 18.66-34.46Z",
    style: {
      fill: "url(#create_api_connection_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.02 113.2 8.96 3.03a62.3 62.3 0 0 0 6.67 15.29l-3.9 8.71c-.43.95-.21 2.07.53 2.8L28.3 156.7c.76.74 1.89.92 2.84.45l8.58-4.24c4.84 2.8 10.08 4.87 15.53 6.13l3.33 8.94c.36.98 1.29 1.62 2.33 1.62h.04l8.71-.15a2.49 2.49 0 0 0-.08-4.98l-6.95.12-3.18-8.56c-.3-.81-.99-1.4-1.83-1.57-5.83-1.2-11.41-3.4-16.48-6.5-.73-.45-1.64-.49-2.4-.11l-8.21 4.06-11.51-11.23 3.73-8.33c.34-.76.28-1.65-.17-2.35a57.4 57.4 0 0 1-7.12-16.33c-.21-.81-.82-1.46-1.61-1.73l-8.55-2.89L5.03 93l8.56-3.18c.81-.3 1.4-.99 1.57-1.83 1.2-5.83 3.4-11.41 6.5-16.48.45-.73.49-1.64.11-2.4l-4.06-8.21 11.23-11.51 8.33 3.73c.76.34 1.65.28 2.35-.17a57.4 57.4 0 0 1 16.33-7.12c.81-.21 1.46-.82 1.73-1.61l2.9-8.55 9.1-.15a2.49 2.49 0 0 0 2.45-2.53 2.497 2.497 0 0 0-2.53-2.45l-10.85.18c-1.05.02-1.98.7-2.32 1.69l-3.04 8.96a62.5 62.5 0 0 0-15.29 6.67l-8.71-3.91c-.95-.43-2.07-.21-2.8.53L12.92 58.67a2.48 2.48 0 0 0-.45 2.84l4.24 8.58a56.4 56.4 0 0 0-6.13 15.53l-8.94 3.32C.65 89.31 0 90.26.02 91.32l.33 19.57c.02 1.05.7 1.98 1.69 2.31Z",
    style: {
      fill: "url(#create_api_connection_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.63 97.5v4.98h99.32c1.28 6.65 7.41 11.24 14.16 10.6 6.75-.65 11.9-6.31 11.9-13.08s-5.15-12.44-11.9-13.08c-6.74-.65-12.87 3.94-14.16 10.6H74.63Zm106.44-3.28c3.18-3.18 8.35-3.18 11.53 0s3.18 8.35 0 11.53-8.35 3.18-11.53 0a8.16 8.16 0 0 1 0-11.53",
    style: {
      fill: "url(#create_api_connection_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8 51.5c-6.29 0-11.7 4.46-12.9 10.64h-20.97c-7.36 0-13.32 5.97-13.33 13.33 0 4.61-3.74 8.35-8.35 8.35H74.62v4.98h22.63c7.36 0 13.32-5.97 13.33-13.33 0-4.61 3.74-8.35 8.35-8.35h20.97c1.31 6.8 7.69 11.42 14.56 10.54s11.88-6.94 11.44-13.86-6.18-12.3-13.11-12.3Zm5.77 18.9a8.15 8.15 0 0 1-11.52 0 8.15 8.15 0 0 1 0-11.52 8.15 8.15 0 0 1 11.52 0c3.18 3.19 3.18 8.35 0 11.53Z",
    style: {
      fill: "url(#create_api_connection_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.8 148.47c6.93 0 12.66-5.39 13.1-12.3s-4.57-12.98-11.44-13.86-13.24 3.73-14.56 10.53h-20.97c-4.61 0-8.35-3.74-8.35-8.35 0-7.36-5.97-13.32-13.33-13.33H74.62v4.98h22.63c4.61 0 8.35 3.74 8.35 8.35 0 7.36 5.97 13.32 13.33 13.33h20.97c1.2 6.18 6.6 10.64 12.9 10.64Zm-5.76-18.9c3.18-3.18 8.35-3.18 11.53 0s3.18 8.35 0 11.53-8.35 3.18-11.53 0a8.16 8.16 0 0 1-2.4-5.77c0-2.17.86-4.24 2.4-5.77Z",
    style: {
      fill: "url(#create_api_connection_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.77 154.55c-2.16 2.15-3.5 4.99-3.79 8.02h-2.82c-4.66-.01-8.83-2.92-10.47-7.29l-7.05-19.04a16.2 16.2 0 0 0-15.14-10.53h-6.88v4.98h6.88c4.67.01 8.84 2.92 10.47 7.28l7.05 19.04a16.21 16.21 0 0 0 15.14 10.54h3.29c1.67 5.68 6.93 9.53 12.84 9.43a13.137 13.137 0 0 0 6.26-24.55 13.13 13.13 0 0 0-15.79 2.13Zm17.44 9.28a8.152 8.152 0 0 1-15.68 3.12 8.144 8.144 0 0 1 3-9.89 8.15 8.15 0 0 1 10.29 1.01c1.53 1.53 2.4 3.6 2.39 5.77Z",
    style: {
      fill: "url(#create_api_connection_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.64 63.73 7.05-19.04c1.63-4.37 5.8-7.27 10.47-7.29h2.82c.66 6.72 6.31 11.84 13.06 11.82 6.75 0 12.38-5.15 13.02-11.87s-3.93-12.82-10.56-14.1-13.14 2.69-15.05 9.16h-3.29c-6.75.02-12.78 4.22-15.14 10.54l-7.05 19.04c-1.63 4.37-5.8 7.27-10.47 7.28h-6.88v4.98h6.88c6.75-.02 12.78-4.22 15.14-10.53Zm27.65-33.36a8.15 8.15 0 0 1 10.29-1.01 8.157 8.157 0 0 1-6.12 14.78 8.16 8.16 0 0 1-6.56-8c0-2.16.86-4.24 2.39-5.76Z",
    style: {
      fill: "url(#create_api_connection_svg2__h)"
    }
  }));
};
export default SvgCreateApiConnection;